// extracted by mini-css-extract-plugin
export var active = "_65-b";
export var activeIndicator = "_65-6";
export var animate = "_65-a";
export var disabled = "_65-c";
export var flat = "_65-1";
export var fullWidth = "_65-3";
export var lg = "_65-9";
export var md = "_65-8";
export var redoButtonTabGroup = "_65-0";
export var sm = "_65-7";
export var tabButton = "_65-4";
export var tabButtonsContainer = "_65-2";
export var xs = "_65-5";